import { UiColor } from '@src/types'
import { ThemeColor } from './theme'

export const UI_COLORS_MAPPING: { [key in UiColor]: ThemeColor | undefined } = {
  [UiColor.Success]: 'theme.success.base',
  [UiColor.Error]: 'theme.error.base',
  [UiColor.Warning]: 'theme.warning.base',
  [UiColor.Info]: 'theme.info.base',
}
